import { PageWithLayout } from '@/pages/_app';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { MailConfigurationContent } from '@/pageContents/mailConfiguration/MailConfigurationContent';
import { Permission } from '@/models/user';

const MailConfiguration: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Mailkonfiguration | Starjack Backoffice</title>
            </Helmet>

            <MailConfigurationContent />
        </>
    );
};

MailConfiguration.isProtected = true;
MailConfiguration.getLayout = (Component) => (
    <SidebarLayout>{Component}</SidebarLayout>
);
MailConfiguration.permissions = [Permission.MAIL_CONFIGURATION_NAV];

export default MailConfiguration;
